module.exports = __webpack_public_path__ + "static/media/22.9a862261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/22.jpg
// module id = 583
// module chunks = 0